import { useEffect, useState } from 'react';
import { StreamrTvBroadcaster } from '../engine/StreamrTvBroadcaster';
import { KeyStore } from '../engine/helpers/KeyStore';
import { useSetViewerCountCallback } from '../state/viewerCountState';
export function useStreamrTvBroadcaster(streamId) {
    const [broadcaster, setBroadcaster] = useState();
    const setViewerCountCallback = useSetViewerCountCallback();
    useEffect(function setupBroadcaster() {
        if (!setViewerCountCallback) {
            return;
        }
        let mounted = true;
        function onViewerCountChanged(streamId, count) {
            setViewerCountCallback(streamId, count);
        }
        const newBroadcaster = new StreamrTvBroadcaster(KeyStore.getInstance().getAesKey(streamId));
        newBroadcaster.on('viewerCountChanged', onViewerCountChanged);
        (async () => {
            try {
                await newBroadcaster.start(streamId);
                if (!mounted) {
                    return;
                }
                setBroadcaster(newBroadcaster);
            }
            catch (e) {
                console.error(e);
            }
        })();
        return () => {
            mounted = false;
            newBroadcaster?.off('viewerCountChanged', onViewerCountChanged);
            newBroadcaster?.stop().catch(console.error.bind(console));
        };
    }, [setViewerCountCallback, streamId]);
    return broadcaster;
}
